import * as React from 'react'
import { Link } from 'react-router-dom'
import Edit from '../icons/organizations/Edit'
import Organization from '../icons/organizations/Organization'
import Dots from '../icons/ui/Dots'
import * as classNames from 'classnames'

interface IOrganizationTableModalProps {
  handleSwitchOrg: () => void
  path: string
  id: string
  isSelected: boolean
}

interface IOrganizationTableModalState {
  isModalOpen: boolean
}

class OrganizationTableModal extends React.Component<IOrganizationTableModalProps, IOrganizationTableModalState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isModalOpen: false
    }
  }

  public mouseEnter = () => this.setState({ isModalOpen: true })
  public mouseLeave = () => this.setState({ isModalOpen: false })
  public handleSwitchOrg = () => {
    if (!this.props.isSelected) {
      this.props.handleSwitchOrg()
    }
  }

  public render() {
    const isSelectedClasses = classNames('flex col-12 cursor--pointer', { 'svg-green': this.props.isSelected })
    return (
      <div className='relative'>
        <div className='cursor--pointer p1' onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
          <Dots />
        </div>
        {this.state.isModalOpen && (
          <div
            className='absolute bg-white box-s box-sizing modal-shadow p2 right-2 rounded top-0 w160 z2'
            onMouseEnter={this.mouseEnter}
            onMouseLeave={this.mouseLeave}
          >
            <Link to={`${this.props.path}/${this.props.id}/edit/organization-info`}>
              <div className='flex col-12 mb1 cursor--pointer'>
                <Edit />
                <div className='Edit ml2'>Edit</div>
              </div>
            </Link>
            <div className={isSelectedClasses} onClick={this.handleSwitchOrg}>
              <Organization />
              <div className='Tw ml2'>Switch</div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default OrganizationTableModal



// WEBPACK FOOTER //
// ./src/components/organizations/OrganizationTableModal.tsx